import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_LeLj4VgRBpgS: {
	id: 'prd_LeLj42DEV2VgRBpgS'
	ident: 'prd_LeLj4VgRBpgS'
	sku: 'simple_premium_1w_4_15_4w_44_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 1
			iteration_count: 1
			price_id: 'prc_r3CO62DEV2EE7cY4x'
			amount: 9.99
			amount_usd: 4.15
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 4.15
			discount: 5.84
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: null
			price_id: 'prc_0P0wM2DEV2ibjGlme'
			amount: 44
			amount_usd: 44
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_LeLj4VgRBpgS, SubscriptionProduct>
const prd_LeLj4VgRBpgS = { ident: 'prd_LeLj4VgRBpgS' } as typeof _prd_LeLj4VgRBpgS

export default prd_LeLj4VgRBpgS
